import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { get1DDataXY } from '../../data/data1d/Spectrum1D/get1DDataXY';
import { isSpectrum1D } from '../../data/data1d/Spectrum1D/isSpectrum1D';
import { useChartData } from '../context/ChartContext';
import { useScaleChecked } from '../context/ScaleContext';
import { useActiveSpectra } from '../hooks/useActiveSpectra';
import { useSetActiveSpectrumAction } from '../hooks/useSetActiveSpectrumAction';
import { useVerticalAlign } from '../hooks/useVerticalAlign';
import Line from './Line';
import { SPECTRA_BOTTOM_MARGIN } from './utilities/scale';
const BOX_SIZE = 10;
const style = css `
  fill: transparent;

  &:hover {
    fill: #ff6f0057;
  }
`;
function LinesSeries() {
    const { data, displayerKey, xDomains, width, margin, height, toolOptions: { selectedTool }, } = useChartData();
    const activeSpectra = useActiveSpectra();
    const { shiftY } = useScaleChecked();
    const verticalAlign = useVerticalAlign();
    const innerWidth = width - margin.left - margin.right;
    const innerHeight = height - margin.bottom - SPECTRA_BOTTOM_MARGIN;
    const spectra = (data?.filter((d) => isSpectrum1D(d) && d.display.isVisible && xDomains[d.id]) || []);
    const { setActiveSpectrum } = useSetActiveSpectrumAction();
    return (_jsxs("g", { clipPath: `url(#${displayerKey}clip-chart-1d)`, className: "spectra", children: [spectra.map((d, i) => (_jsxs("g", { children: [_jsx(Line, { display: d.display, id: d.id, data: get1DDataXY(d), index: i }), verticalAlign === 'stack' && selectedTool === 'zoom' && (_jsx("rect", { css: style, y: innerHeight - shiftY * i - BOX_SIZE / 2, x: margin.left, width: `${innerWidth}px`, height: `${BOX_SIZE}px`, onClick: (e) => {
                            setActiveSpectrum(e, d.id);
                        }, "data-no-export": "true" }))] }, d.id))), activeSpectra?.map((activeSpectrum) => (_jsx("use", { href: `#${activeSpectrum.id}` }, activeSpectrum.id)))] }));
}
export default LinesSeries;
